import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import Search from "../../components/Search";
import { t } from "i18next";
import CustomImageComponent from "../../components/CustomImageComponent";

const HeroBannerSec = (props) => {
  const { data, filters } = props;
  const counterRefs = useRef([]);
  const heroImage = data?.sectionItems?.[0]?.image;

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          const countTo = parseInt(el.getAttribute("data-count"), 10);

          if (entry.isIntersecting && !el.dataset.animated) {
            animateCount(el, countTo);
            el.dataset.animated = "true";
          }
        });
      },
      { threshold: 0.6 }
    );

    counterRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      counterRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  const animateCount = (el, countTo) => {
    let start = 0;
    const duration = 2500;
    const increment = countTo / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= countTo) {
        el.textContent = countTo;
        clearInterval(timer);
      } else {
        el.textContent = Math.floor(start);
      }
    }, 16);
  };

  return (
    <>
      {heroImage && (
        <Helmet>
          <link rel="preload" as="image" href={heroImage} fetchPriority="high" />
        </Helmet>
      )}
      {data && (
        <>
          <section className="banner-section">
            {heroImage && (
              <img
                src={heroImage}
                alt=""
                className="banner-section__bg"
                fetchPriority="high"
                loading="eager"
                decoding="async"
              />
            )}
            <div className="container banner-section__content">
              <div className="row align-items-center">
                <div
                  className="col-md-12 col-lg-6 left-block"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <span>{data?.sectionTitle || ""}</span>
                  <h1>{data?.sectionHeader || ""}</h1>
                  <p>{data?.sectionDescription || ""}</p>
                </div>
                <div
                  className="col-md-12 col-lg-6"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  {data?.sectionItems?.[1]?.image && (
                    <CustomImageComponent
                      src={data.sectionItems[1].image}
                      alt="banner-img"
                      className="img-fluid"
                      loading="lazy"
                      decoding="async"
                    />
                  )}
                </div>
              </div>
              <Search filters={filters} />
            </div>

            <section
              className="banner-counter-section desk-disply"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <ul className="counter-listing">
                <li>
                  <div className="counter-box">
                    <h4>
                      <span className="counter" data-count="96" ref={(el) => (counterRefs.current[0] = el)}>
                        0
                      </span>
                      +
                    </h4>
                    <p>{t("award_winning")}</p>
                  </div>
                </li>
                <li>
                  <div className="counter-box">
                    <h4>
                      <span className="counter" data-count="8" ref={(el) => (counterRefs.current[1] = el)}>
                        0
                      </span>
                      K+
                    </h4>
                    <p>{t("happy_customer")}</p>
                  </div>
                </li>
                <li>
                  <div className="counter-box">
                    <h4>
                      <span className="counter" data-count="20" ref={(el) => (counterRefs.current[2] = el)}>
                        0
                      </span>
                      K+
                    </h4>
                    <p>{t("property_ready")}</p>
                  </div>
                </li>
              </ul>
            </section>
          </section>

          <section className="mob-counter-section mob-disply" data-aos="fade-up" data-aos-duration="1500">
            <ul className="counter-listing">
              <li>
                <div className="counter-box">
                  <h4>
                    <span className="counter" data-count="96" ref={(el) => (counterRefs.current[3] = el)}>
                      0
                    </span>
                    +
                  </h4>
                  <p>{t("award_winning")}</p>
                </div>
              </li>
              <li>
                <div className="counter-box">
                  <h4>
                    <span className="counter" data-count="8" ref={(el) => (counterRefs.current[4] = el)}>
                      0
                    </span>
                    K+
                  </h4>
                  <p>{t("happy_customer")}</p>
                </div>
              </li>
              <li>
                <div className="counter-box">
                  <h4>
                    <span className="counter" data-count="20" ref={(el) => (counterRefs.current[5] = el)}>
                      0
                    </span>
                    K+
                  </h4>
                  <p>{t("property_ready")}</p>
                </div>
              </li>
            </ul>
          </section>
        </>
      )}
    </>
  );
};

export default HeroBannerSec;
